// extracted by mini-css-extract-plugin
export default {"logoutBtn":"GOpAh","logoutIcon":"XC4vS"};